import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { CreateSubmissionPayloadDto } from 'libs/pinnacle-sdk';
import { initialValues } from 'components/features/create-submission-form/form';
import { EStoreKeys } from './keys';

interface SubmissionFormState {
  formData: Partial<CreateSubmissionPayloadDto> & { insuredName?: string };

  setFormData: (
    data: Partial<CreateSubmissionPayloadDto> & { insuredName?: string }
  ) => void;
  resetForm: () => void;
  updateFormData: (
    data: Partial<CreateSubmissionPayloadDto> & { insuredName?: string }
  ) => void;
}

export const useSubmissionFormStore = create<SubmissionFormState>()(
  persist(
    (set) => ({
      formData: initialValues,

      setFormData: (data) =>
        set({
          formData: data,
        }),

      updateFormData: (data: Partial<CreateSubmissionPayloadDto>) =>
        set((state) => ({
          formData: { ...state.formData, ...data },
        })),

      resetForm: () =>
        set({
          formData: initialValues,
        }),
    }),
    {
      name: EStoreKeys.SUBMISSION_FORM,
      partialize: (state) => ({
        formData: state.formData,
      }),
    }
  )
);
